module.exports = __webpack_public_path__ + "img/zcsjk_diamond.6b5eb689.png";